module.exports = __webpack_public_path__ + "img/rupture.60bb8cb1.png";